import { useRef } from 'react'
import { Canvas } from '@react-three/fiber'
import { 
  OrbitControls, 
  Stars, 
//   Environment, 
//   PerspectiveCamera,
//   EffectComposer,
//   Bloom,
//   ChromaticAberration
} from '@react-three/drei'
import ParticleSystem from '../3d/ParticleSystem'
import FloatingGeometry from '../3d/FloatingGeometry'
import ScrollController from '../3d/ScrollController'
import { useAppStore } from '../../store/appStore'
import * as THREE from 'three'

export default function Scene3D() {
  const { setMousePosition, performance } = useAppStore()
  const particleSystemRef = useRef<THREE.Points>(null)
  const geometriesRef = useRef<THREE.Group>(null)

  const handleMouseMove = (event: React.MouseEvent) => {
    const x = (event.clientX / window.innerWidth) * 2 - 1
    const y = -(event.clientY / window.innerHeight) * 2 + 1
    setMousePosition({ x, y })
  }

  // Adjust particle count based on performance - reduced for better performance
  const particleCount = performance.quality === 'high' ? 2000 : 
                       performance.quality === 'medium' ? 1200 : 800

  return (
    <div 
      className="fixed inset-0 -z-10" 
      onMouseMove={handleMouseMove}
    >
      <Canvas
        camera={{ position: [0, 0, 10], fov: 75 }}
        gl={{ 
          antialias: false, 
          alpha: true,
          powerPreference: 'high-performance',
          pixelRatio: Math.min(window.devicePixelRatio, 2)
        }}
        dpr={[1, 2]}
      >
        <color attach="background" args={['#0f0f23']} />
        <fog attach="fog" args={['#0f0f23', 15, 40]} />
        
        {/* Lighting */}
        <ambientLight intensity={0.4} color="#f8fafc" />
        <pointLight position={[10, 10, 10]} intensity={0.8} color="#e2e8f0" />
        <pointLight position={[-10, -10, -10]} intensity={0.6} color="#cbd5e1" />
        <directionalLight position={[5, 5, 5]} intensity={0.5} color="#f1f5f9" />
        
        {/* Background Stars */}
        <Stars 
          radius={100} 
          depth={50} 
          count={2000} 
          factor={4} 
          saturation={0} 
          fade 
        />
        
        {/* Scroll Controller for animations */}
        <ScrollController 
          particleSystemRef={particleSystemRef}
          geometriesRef={geometriesRef}
        />
        
        {/* Main Particle System */}
        <ParticleSystem ref={particleSystemRef} count={particleCount} size={2} />
        
        {/* Floating Geometries */}
        <group ref={geometriesRef}>
          <FloatingGeometry 
            position={[-4, 2, -2]} 
            geometry="icosahedron" 
            color="#e2e8f0" 
          />
          <FloatingGeometry 
            position={[4, -1, -3]} 
            geometry="torus" 
            color="#cbd5e1" 
          />
          <FloatingGeometry 
            position={[-2, -3, 1]} 
            geometry="octahedron" 
            color="#94a3b8" 
          />
          <FloatingGeometry 
            position={[3, 3, -1]} 
            geometry="cone" 
            color="#f1f5f9" 
          />
        </group>
        
        {/* Camera Controls */}
        <OrbitControls 
          enableZoom={false}
          enablePan={false}
          enableRotate={false}
          autoRotate={false}
          maxPolarAngle={Math.PI / 2}
          minPolarAngle={Math.PI / 2}
        />
        
  {/* Post Processing removed to avoid missing peer dependency at runtime */}
      </Canvas>
    </div>
  )
}
